import { Injectable } from '@angular/core';

@Injectable()
export class Formvalidator {

    formValidation: any;

    /**
     * Constructor
     */
    constructor() {
        this.setDefault();
    }    

    mailValidator = new RegExp("^(([^<>()\\[\\]\\\\.,;:\\s@\"]+(\\.[^<>()\\[\\]\\\\.,;:\\s@\"]+)*)|(\".+\"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$");
    phoneValidator = new RegExp("^[+\\d ]+[+\\d -]+[\\d\\s]$");

    /**
     * Set default values
     */
    setDefault() {
        this.formValidation = {        
            /* Person */
            ssnError: false,   
            cordNumError: false,        
            firstNameError: false,
            MiddleNameError: false,
            lastNameError: false,
            internalUserNameError: false,
            genderError: false,
            nationalityCodeError: false,
            address_1Error: false,
            address_2Error: false,
            postCodeError: false,
            cityError: false,
            personTitleError: false,
            personPhoneError: false,
            personEmailError: false,
            passportNumberError: false,
            employedByCustomerError: false,
            addressInt_1Error: false,
            addressInt_2Error: false,
            postCodeIntError: false,
            cityIntError: false,

            /* FellowApplicant */
            faSsnError: false,
            faFirstNameError: false,
            faLastNameError: false,

            /* Security Clearance Call Date */
            projectDateError: false,
        }
    }    
    
    /**
     * FellowApplicantForm validation when saving
     * @param fellowApplicantForm FormGroup
     */
    validateFellowApplicantForm(fellowApplicantForm) {            
        if(this.validateFASsn(fellowApplicantForm)) { 
            return true; 
        }
        return false;
    }

        /**
     * Validator function to verify that we send a department ID when create/update a employer
     * @param departmentId Department id     
     */
    validateDepartmentId(departmentId) {
        if(departmentId != undefined && departmentId != null && departmentId != NaN) {
            return this.formValidation.departmentId = true;
        } else {           
            return this.formValidation.departmentId = false;
        }
    }
    
    /**
    * Validate person phone number
    * Telefonnummer måste bestå av endast siffror, mellanslag eller '-' för att godkännas. Till exempel '1234567890', '1234-567890' eller '1234 567890'
    * @param personPhone person phone number
    */
   validatePersonPhone(personPhone) {          
        personPhone = personPhone.replaceAll(" ", "")  // strip out all white spaces
        if (personPhone === null || personPhone.trim().length < 1) {
            this.formValidation.personPhoneError = false;
        } else if (personPhone != null &&  personPhone.trim().length < 5) {
           this.formValidation.personPhoneError = true;           
       } else {
            if (!personPhone.match(/^[0-9-+]+$/g)) {                
                return this.formValidation.personPhoneError = true;
            } else {
                return this.formValidation.personPhoneError = false;                
            }
       }
       return !this.formValidation.personPhoneError;
   }
  
    /**
     * Validate person title/profession
     * @param personTitle person title/profession
     */
    validatePassportNumber(nationalityCode,passportNumber) {
        if(nationalityCode != 'SE') {
            if (passportNumber === null || passportNumber.trim().length < 2 || passportNumber === "") {
                this.formValidation.passportNumberError = true;                
            } else {
                this.formValidation.passportNumberError = false; 
            }
            return !this.formValidation.passportNumberError;
        }
        return this.formValidation.passportNumberError = true;
    }

    /**
     * Validate length of first name
     * @param firstName firstName
     */
    validateFirstName(firstName) {
        if (firstName === null || firstName.trim().length < 2) {
            this.formValidation.firstNameError = true;           
        } else {
            this.formValidation.firstNameError = false; 
        }
        return !this.formValidation.firstNameError;
    }

    /**
    * Validate length of middle name
    * @param middleName middleName
    */
    validateMiddleName(middleName) {
        if (middleName === null || middleName.trim().length < 1) {
            return  this.formValidation.middleNameError = false; 
        } else if (middleName.trim().length < 2) {
            return this.formValidation.middleNameError = true;           
        } else {
            return this.formValidation.middleNameError = false; 
        }       
    }

    /**
     * Validate length of first name in FellowApplicantForm
     * @param firstName firstName
     */
    validateFAFirstName(firstName) {
        if (firstName === null || firstName.trim().length < 2 || this.noneAllowedNameCharacters(firstName)) {            
            this.formValidation.faFirstNameError = true;           
        } else {
            this.formValidation.faFirstNameError = false; 
        }
        return !this.formValidation.faFirstNameError;
    }

    /**
     * Validate length of last name
     * @param lastName lastName
     */
    validateLastName(lastName) {
        if (lastName === null || lastName.trim().length < 2) {
            this.formValidation.lastNameError = true;           
        } else {
            this.formValidation.lastNameError = false;
        }
        return !this.formValidation.lastNameError;
    }    

    validateInternalUserName(internalUserName) {
        if (internalUserName === null || internalUserName.trim().length < 2 || this.noneAllowedNameCharacters(internalUserName)) {
            this.formValidation.internalUserNameError = true;           
        } else {
            this.formValidation.internalUserNameError = false;
        }
        return !this.formValidation.internalUserNameError;
    }   


    /**
     * Validate length of last name in FellowApplicantForm
     * @param lastName lastName
     */
    validateFALastName(lastName) {
        if (lastName === null || lastName.trim().length < 2  || this.noneAllowedNameCharacters(lastName)) {
            this.formValidation.faLastNameError = true;          
        } else {
            this.formValidation.faLastNameError = false;
        }
        return !this.formValidation.faLastNameError;
    }


    /**
     * Validate none allowed name characters
     * @param str 
     * @returns true or false
     */
    noneAllowedNameCharacters(str: String) : Boolean {        
        if (str.match(/^\w+[_()0-9]+$/)) {
            return true;
        } 
        return false;
    }

    /**
     * Validate if gender is selected
     * @param gender MALE or FEMALE
     */
    validateGender(gender) {
        if (gender === null) {
            this.formValidation.genderError = true;            
        } else {
            this.formValidation.genderError = false;
        }
        return !this.formValidation.genderError;
    }

    validateEmployedByCustomer(employedByCustomer) {
        if (employedByCustomer == null) {           
            this.formValidation.employedByCustomerError = true;
        }
        else {
            this.formValidation.employedByCustomerError = false;
        }
        return !this.formValidation.employedByCustomerError;
    }


    /**
     * Validate if nationalityCode is selected
     * @param nationalityCode code for the selected nationality
     */
    validateNationalityCode(nationalityCode) {
        if (nationalityCode === null) {
            this.formValidation.nationalityCodeError = true;           
        } else {
            this.formValidation.nationalityCodeError = false;
        }
        return !this.formValidation.nationalityCodeError;
    }

    /**
     * Validate length of address_1
     * @param address_1 
     */
    validateAddress_1(address_1) {
        if (address_1 === null || address_1.trim().length < 1) {
            this.formValidation.address_1Error = false;
        } else if (address_1.trim().length > 0 && address_1.trim().length < 2) {
            this.formValidation.address_1Error = true;           
        } else {
            this.formValidation.address_1Error = false;  
        }
        return !this.formValidation.address_1Error;
    }

    /**
     * Validate length of international homr address_1
     * @param address_1 
     */
     validateAddressInt_1(address_1) {        
        if (address_1 === null || address_1.trim().length < 1) {
            return this.formValidation.addressInt_1Error = false;
        } else if (address_1.trim().length > 0 && address_1.trim().length < 2) {
            return this.formValidation.addressInt_1Error = true;           
        } else {
            return this.formValidation.addressInt_1Error = false;  
        }       
    }

    /**
     * Validate length of address_2
     * @param address_2 
     */
     validateAddress_2(address_2) {
        if (address_2 === null || address_2.trim().length < 1) {
            this.formValidation.address_2Error = false;
        } else if (address_2.trim().length > 0 && address_2.trim().length < 2) {
            this.formValidation.address_2Error = true;           
        } else {
            this.formValidation.address_2Error = false;  
        }
        return !this.formValidation.address_2Error;
    }

    /**
     * Validate length of international home address_2
     * @param address_2 
     */
     validateAddressInt_2(address_2) {
        if (address_2 === null || address_2.trim().length < 1) {
            return this.formValidation.addressInt_2Error = false;
        } else if (address_2.trim().length > 0 && address_2.trim().length < 2) {
            return this.formValidation.addressInt_2Error = true;           
        } else {
            return this.formValidation.addressInt_2Error = false;  
        }        
    }

    /**
     * Validate postal code
     * @param postCode post code number
     */
    validatePostCode(postCode) {
        if (postCode === null || postCode.trim().length < 1) {
            return this.formValidation.postCodeError = false;
        } else if (postCode.trim().length < 2) {
            return this.formValidation.postCodeError = true;           
        } else {
            postCode = postCode.replace(" ", "")  // strip out all white spaces
            if (isNaN(postCode.trim())) {               
                return this.formValidation.postCodeError = true;               
            } else {
                return this.formValidation.postCodeError = false;                
            }
        }        
    }

     /**
     * Validate intenational home postal code
     * @param postCode post code number
     */
      validatePostCodeInt(postCode) {
        if (postCode === null || postCode.trim().length < 1) {
            return this.formValidation.postCodeIntError = false;
        } else if (postCode.trim().length < 2) {
            return this.formValidation.postCodeIntError = true;           
        } else {
            postCode = postCode.replace(" ", "")  // strip out all white spaces
            if (isNaN(postCode.trim())) {               
                return this.formValidation.postCodeIntError = true;               
            } else {
                return this.formValidation.postCodeIntError = false;                
            }
        }        
    }

    /**
     * Validate city
     * @param city name of city
     */
    validateCity(city) {
        if (city === null || city.trim().length < 1) {
            return this.formValidation.cityError = false; 
        } else if (city.trim().length < 2) {
            return this.formValidation.cityError = true;           
        } else {
            return this.formValidation.cityError = false; 
        }       
    }

    /**
     * Validate international home city
     * @param city name of city
     */
     validateCityInt(city) {
        if (city === null || city.trim().length < 1) {
            return this.formValidation.cityIntError = false; 
        } else if (city.trim().length < 2) {
            return this.formValidation.cityIntError = true;           
        } else {
            return this.formValidation.cityIntError = false; 
        }       
    }

    setSsnValidation(nonSsn) {
        return nonSsn ? this.formValidation.ssnError = false : this.formValidation.ssnError = true;
    }

    /**
     * Validate swedish social security number
     * @param ssn social security number
     * @param ssn_old previous social security number
     * @param noSsn true/false if ssn exists
     */
    validateSsn(ssn, ssn_old, noSsn, nationalityCode, modalData = ["", ""]) {
        if(nationalityCode != 'SE' || nationalityCode == null) {
            this.formValidation.ssnError = false;
            return !this.formValidation.ssnError;
        }

        if(noSsn) {
            this.formValidation.ssnError = false;
            return !this.formValidation.ssnError;
        }
        
        if (ssn === null || ssn === "") {
            this.formValidation.ssnError = true;
            modalData[0] = "Fel i fält: Personnummer";
            modalData[1] = "Fältet är tomt.";
            return !this.formValidation.ssnError;
        }
        if (nationalityCode === 'SE') {
            ssn = ssn.match(/[0-9]{8}-[0-9]{2}([0-9]{2}|TF)/g);
            if(ssn === null){
                this.formValidation.ssnError = true;
                modalData[0] = "Fel i fält: Personnummer";
                modalData[1] = "Personnumret är felaktigt formaterat.";
                return !this.formValidation.ssnError;
            } else {
                ssn = ssn[0];
            }
            if(ssn.slice(-2) === "TF") {
                this.formValidation.ssnError = false;  
                return !this.formValidation.ssnError;
            }
            else{
                ssn = ssn
                .replace(/\D/g, "")     // strip out all but digits
                .split("")              // convert string to array
                .reverse()              // reverse order for Luhn
                .slice(0, 10);          // keep only 10 digits (i.e. 1977 becomes 77)

                // verify we got 10 digits, otherwise it is invalid
                if (ssn.length != 10) {      
                    this.formValidation.ssnError = true;
                    modalData[0] = "Fel i fält: Personnummer";
                    modalData[1] = "Personnumret är felaktigt formaterat.";
                    return !this.formValidation.ssnError;
                }

                var sum = ssn
                    // convert to number
                    .map(function(n) {
                        return Number(n);
                    })
                    // perform arithmetic and return sum
                    .reduce(function(previous, current, index) {
                        // multiply every other number with two
                        if (index % 2) current *= 2;
                        // if larger than 10 get sum of individual digits (also n-9)
                        if (current > 9) current -= 9;
                        // sum it up
                        return previous + current;
                    });

                // sum must be divisible by 10   
                if (0 === sum % 10) {
                    this.formValidation.ssnError = false;              
                    return true;     
                } else {
                    this.formValidation.ssnError = true;
                    modalData[0] = "Fel i fält: Personnummer";
                    modalData[1] = "Personnumret är korrekt formaterat, men inte giltigt. Kontrollera att du skrivit rätt.";
                    return false;     
                }
            }
        } else {
        this.formValidation.ssnError = false;
        return true;
        }
    }

    /**
     * Validate social security number for FellowApplicant
     * @param fellowApplicantForm form to be validated
     */
    validateFASsn(fellowApplicantForm, modalData = ["", ""]) {
        let swedishNationality = true;
        let ssn = fellowApplicantForm.ssn;

        if(fellowApplicantForm.notSwedish) {
            swedishNationality = false;
        }

        if(!swedishNationality) {
            this.formValidation.faSsnError = false;
            return !this.formValidation.faSsnError;
        }
        
        if (fellowApplicantForm.ssn === null || fellowApplicantForm.ssn === "") {
            this.formValidation.faSsnError = true;
            modalData[0] = "Fel i fält för medsökande: Personnummer";
            modalData[1] = "Fältet är tomt.";
            return !this.formValidation.faSsnError;
        }
        if (swedishNationality) {
            ssn = ssn.match(/[0-9]{8}-[0-9]{2}([0-9]{2}|TF)/g);
            if(ssn === null){
                this.formValidation.faSsnError = true;
                modalData[0] = "Fel i fält för medsökande: Personnummer";
                modalData[1] = "Personnumret är felaktigt formaterat.";
                return !this.formValidation.faSsnError;
            } else {
                ssn = ssn[0];
            }
            if(ssn.slice(-2) === "TF") {
                this.formValidation.faSsnError = false;  
                return !this.formValidation.faSsnError;
            }
            else{
                ssn = ssn
                .replace(/\D/g, "")     // strip out all but digits
                .split("")              // convert string to array
                .reverse()              // reverse order for Luhn
                .slice(0, 10);          // keep only 10 digits (i.e. 1977 becomes 77)

                // verify we got 10 digits, otherwise it is invalid
                if (ssn.length != 10) {      
                    this.formValidation.faSsnError = true;
                    modalData[0] = "Fel i fält för medsökande: Personnummer";
                    modalData[1] = "Personnumret är felaktigt formaterat.";
                    return !this.formValidation.faSsnError;
                }

                var sum = ssn
                    // convert to number
                    .map(function(n) {
                        return Number(n);
                    })
                    // perform arithmetic and return sum
                    .reduce(function(previous, current, index) {
                        // multiply every other number with two
                        if (index % 2) current *= 2;
                        // if larger than 10 get sum of individual digits (also n-9)
                        if (current > 9) current -= 9;
                        // sum it up
                        return previous + current;
                    });

                // sum must be divisible by 10   
                if (0 === sum % 10) {
                    this.formValidation.faSsnError = false;              
                    return true;     
                } else {
                    this.formValidation.faSsnError = true;
                    modalData[0] = "Fel i fält för medsökande: Personnummer";
                    modalData[1] = "Personnumret är korrekt formaterat, men inte giltigt. Kontrollera att du skrivit rätt.";
                    return false;     
                }
            }
        } else {
        this.formValidation.faSsnError = false;
        return true;
        }
    }

    /**
     * Validate swedish social security number
     * @param coordinationNumber coordination number
     * @param noCordNum true/false if coordination number exists
     */
    validateCoordinationNumber(coordinationNumber, noCordNum, nationalityCode, modalData = ["", ""]) {
        if(nationalityCode != 'SE' || nationalityCode == null) {
            this.formValidation.cordNumError = false;
            return !this.formValidation.cordNumError;
        }

        if(noCordNum) {
            this.formValidation.cordNumError = false;
            return !this.formValidation.cordNumError;
        }
        
        if (nationalityCode === 'SE') {
            coordinationNumber = coordinationNumber.match(/[0-9]{8}-[0-9]{2}([0-9]{2}|TF)/g);
            if(coordinationNumber === null){
                this.formValidation.cordNumError = true;
                modalData[0] = "Fel i fält: Samordningsnummer";
                modalData[1] = "Samordningsnummer är felaktigt formaterat.";
                return !this.formValidation.cordNumError;
            } else {
                coordinationNumber = coordinationNumber[0];
            }
            if(coordinationNumber.slice(-2) === "TF") {
                this.formValidation.cordNumError = false;  
                return !this.formValidation.cordNumError;
            }
            else{
                coordinationNumber = coordinationNumber
                .replace(/\D/g, "")     // strip out all but digits
                .split("")              // convert string to array
                .reverse()              // reverse order for Luhn
                .slice(0, 10);          // keep only 10 digits (i.e. 1977 becomes 77)

                // verify we got 10 digits, otherwise it is invalid
                if (coordinationNumber.length != 10) {      
                    this.formValidation.cordNumError = true;
                    modalData[0] = "Fel i fält: Samordningsnummer";
                    modalData[1] = "Samordningsnummer är felaktigt formaterat.";
                    return !this.formValidation.cordNumError;
                }

                var sum = coordinationNumber
                    // convert to number
                    .map(function(n) {
                        return Number(n);
                    })
                    // perform arithmetic and return sum
                    .reduce(function(previous, current, index) {
                        // multiply every other number with two
                        if (index % 2) current *= 2;
                        // if larger than 10 get sum of individual digits (also n-9)
                        if (current > 9) current -= 9;
                        // sum it up
                        return previous + current;
                    });

                // sum must be divisible by 10   
                if (0 === sum % 10) {
                    this.formValidation.cordNumError = false;              
                    return true;     
                } else {
                    this.formValidation.cordNumError = true;
                    modalData[0] = "Fel i fält: Samordningsnummer";
                    modalData[1] = "Samordningsnummer är korrekt formaterat, men inte giltigt. Kontrollera att du skrivit rätt.";
                    return false;     
                }
            }
        } else {
        this.formValidation.cordNumError = false;
        return true;
        }
    }

    /**
     * Validate security clearance date (not null) 
     * @param input Date
     * @param modalData Error modal
     */
    validateSecurityClearanceCallDate(input, modalData = ["", ""]) {
        if(isNaN(Date.parse(input)) || input === null) {       
            modalData[0] = "Fel i fält: Datum (Säkerhetssamtal)";
            modalData[1] = "Ett datum måste anges.";
            return this.formValidation.projectDateError = true;
        } else {
            return this.formValidation.projectDateError = false;
        }
    }

     /**
     * Validator to assure a valid email address
     * @param mail Mail     
     */
      validatePersonMail(mail) {
        if (mail === null || mail.length < 1) {
            return this.formValidation.personEmailError = false;
        } else if (!this.isValidContactMail(mail)) {           
            return this.formValidation.personEmailError = true;
        }
        return this.formValidation.personEmailError = false;
    }

    /**
     * Checks the validity of a contact mail and sets modalData error message appropriate to the mail error.
     * @param contactMail E-mail address.     
     */
     isValidContactMail(contactMail) {
        if (this.mailValidator.test(contactMail)) {
            return true;
        }        
        return false;
    }
}
